<template>
  <div class="expenses-widget-container">
    <div v-if="loading" class="expenses-widget-loading">Loading...</div>
    <div v-else-if="error" class="expenses-widget-error">{{ error }}</div>
    <div v-else class="expenses-widget-chart-placeholder">
      <div class="expenses-widget-chart-summary">
        <div class="expenses-widget-chart-summary-item">
          <div class="expenses-widget-chart-summary-label">Total Expenses</div>
          <div class="expenses-widget-chart-summary-value">{{ formatCurrency(totalExpenses) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/ExpensesWidget.css';
import ApiService from '@/services/api.service';
import logger from '@/utils/logger';

export default {
  name: 'ExpensesWidget',
  props: {
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      totalExpenses: 0,
      loading: true,
      error: null
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        // Fetch expenses from VendorPayBill records (created through PayBill.vue)
        // These are actual expense payments made, not account balances
        const expenses = await ApiService.getBillsAndExpenses(this.companyId, { view: 'Expenses' });
        const expensesArray = Array.isArray(expenses) ? expenses : [];
        
        // Filter to only include expenses (not bills) and exclude voided/cancelled
        const validExpenses = expensesArray.filter(expense => {
          return expense.type === 'Expense' &&
                 !expense.voided &&
                 expense.status !== 'voided' &&
                 expense.status !== 'cancelled';
        });
        
        // Sum all expense amounts from VendorPayBill records
        this.totalExpenses = validExpenses.reduce((sum, expense) => {
          return sum + parseFloat(expense.originalAmount || expense.totalAmount || 0);
        }, 0);
      } catch (error) {
        logger.error('Error fetching expenses:', error);
        this.error = 'Failed to load data';
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }
  }
};
</script>

